<template>
  <div class="mark-container">
    <div class="marker-favorites">
      <template v-if="isMultiple">
        <div
          v-for="color in value.color"
          :key="color"
          class="marker-part"
          :style="{ backgroundColor: color }"
        />
      </template>

      <template v-else>
        <div class="marker-part" :style="{ backgroundColor: value.color }" />
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "FavouriteCell",

  props: {
    value: {
      type: Object,
      required: true,
    },
  },

  computed: {
    isMultiple() {
      return Array.isArray(this.value.color);
    },
  },
};
</script>

<style scoped lang="less">
.mark-container {
  width: 100%;
  height: 100%;
  padding: 4px 0;
  display: flex;
  justify-content: center;
}

.marker-favorites {
  width: 8px;
  height: calc(var(--row-height) - 8px);
  border-radius: 1px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.marker-part {
  flex: 1;
}
</style>
